import React from 'react';

const CategoryList = ({ categories, onCategoryClick }) => {
  return (
    <div className='cat-container'>
      {categories.map((category) => (
        <div
          key={category.id}
          className='cat-div'
          onClick={() => onCategoryClick(category.id)}
        >
          {category.image ? (
            <img
              src={category.image.src}
              alt={category.name}
              style={{
                width: '100%',
                height: '150px',
                objectFit: 'cover',
                borderRadius: '8px',
                marginBottom: '10px',
              }}
            />
          ) : (
            <div
              style={{
                width: '100%',
                height: '150px',
                backgroundColor: '#f0f0f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '8px',
                marginBottom: '10px',
              }}
            >
              <span style={{ color: '#888' }}>No Image</span>
            </div>
          )}
          <h3 className='h3'>{category.name}</h3>
        </div>
      ))}
    </div>
  );
};

export default CategoryList;
